import type { LucideIcon } from "lucide-react";
import { Link } from "@/components/ui/link";
import { cn } from "@/lib/utils";
import { TONE_TINT, type Tone } from "./tone";

export type StageTile = {
  key: string;
  icon: LucideIcon;
  tone: Tone;
  count: string;
  label: string;
  /** Where the tile leads, when it leads somewhere. */
  to?: string;
};

const GRID_COLUMNS: Record<number, string> = {
  3: "sm:grid-cols-3",
  5: "sm:grid-cols-5",
};

/** A row of count tiles — the Pipeline's stages, Review status's check statuses. */
export function StageTiles({ tiles }: { tiles: StageTile[] }) {
  return (
    <div className={cn("grid grid-cols-2 gap-3", GRID_COLUMNS[tiles.length])}>
      {tiles.map((tile) => {
        const Icon = tile.icon;
        const body = (
          <>
            <div
              className={cn(
                "flex h-8 w-8 items-center justify-center rounded-lg",
                TONE_TINT[tile.tone],
              )}
            >
              <Icon className="h-4 w-4" />
            </div>
            <div className="space-y-0.5">
              <p className="text-3xl font-bold tracking-tight">{tile.count}</p>
              <p className="text-sm text-muted-foreground">{tile.label}</p>
            </div>
          </>
        );
        const className = "flex flex-col gap-2.5 rounded-lg border p-3.5";
        return tile.to ? (
          <Link
            key={tile.key}
            to={tile.to}
            className={cn(className, "transition-colors hover:bg-accent/50")}
          >
            {body}
          </Link>
        ) : (
          <div key={tile.key} className={className}>
            {body}
          </div>
        );
      })}
    </div>
  );
}
